/* eslint-disable */
import { useEffect, useState, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
// import _ from 'lodash';
import { Button, Tooltip } from '@mui/material';
import { Filter, RefreshCcw, TrainFrontTunnel, Upload } from 'lucide-react';
import styles from './MyAuditsPage.module.scss';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import { notificationServices } from '../../../Services';
import {
	classes,
	filtersInfoChip,
	getActionColumn,
	getFileName,
	handleResponseStreamDownload,
} from '../../../Helpers';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import auditServices from '../../../Services/audit-services';
import { AuditItemsModal } from '../../../Components/Modals/AuditItemsModal';
import AuditCreationModal from '../../../Components/Modals/AuditCreationModal/AuditCreationModal';
import UploadDataModal from '../../../Components/Modals/UploadDataModal/UploadDataModal';
import excel from '../../../Images/excel.svg';
import { formActions, modalActions } from '@/Actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';

const TABLE_COLUMNS = [
	{
		title: 'Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Comment',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Final Audit Count',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Wastage',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatched',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At / Activated At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Action By',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Scheduled/Start',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Scanning Completed At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock Adjustment At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bulk Action',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	Id: 'id',
	Name: 'name',
	Type: 'subType',
	Comment: 'closeComment',
	'Created At / Activated At': 'id',
	Start: 'startDate',
	'Scanning Completed At': 'endDate',
	'Stock Adjustment At': 'stockAdjustmentAt',
	'Store Name': 'storeName',
	Status: 'id',
	'Expected Stock': 'auditStatus.total',
	'Final Audit Count': 'auditStatus.audited',
	Wastage: 'auditStatus.wastage',
	Dispatched: 'auditStatus.dispatched',
	'Created By': 'createdByName',
	'Last Action By': 'lastActionByName',
	'Bulk Action': 'id',
};

const statusList = [
	{
		id: 'COMPLETED',
		title: 'COMPLETED',
	},
	{
		id: 'ACTIVE',
		title: 'ACTIVE',
	},
	{
		id: 'SCHEDULED',
		title: 'SCHEDULED',
	},
	{
		id: 'CLOSED',
		title: 'SCANNING DONE',
	},
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
];

function MyAuditsPage(props) {
	const {
		toggleModal,
		toggleAuditCreationModal,
		toggleAlert,
		fetchProducts,
		productsList,
		showUploadDataModal,
		payload,
		toggleUploadDataModal,
		toggleFiltersDrawer,
		storesList,
	} = props;

	const [isLoading, setIsLoading] = useState(false);
	const [auditsList, setAuditList] = useState([]);
	const [filters, setFilters] = useState({
		store: null,
		dateRange: {
			from: moment(new Date())?.format('YYYY-MM-DD'),
			to: moment(new Date())?.format('YYYY-MM-DD'),
		},
		type: null,
		status: null,
	});
	const [search, setSearch] = useState('');
	const [selectedOption, setSelectedOption] = useState(null);
	const [isRefresh, setIsRefresh] = useState(false);
	const exportFilters = useRef();
	const { userConfig = {} } = useAuth();
	const { userDetails = {}, userRoles = {} } = userConfig || {};
	const { level } = userDetails || {};
	const levels = [1];

	const BASE_COLUMNS = [
		{
			title: 'View',
			config: {
				type: 'VIEW',
			},
		},
	];

	const ADDITIONAL_COLUMNS = [
		{
			title: 'Action',
			config: {
				type: 'CLOSE',
			},
		},
	];

	useEffect(() => {
		fetchProducts({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const fetchAudits = async (request, isRefresh = false) => {
		setIsRefresh(isRefresh);
		if (Object.keys(request ?? {})?.length === 0) {
			request = {
				store: filters?.store?.id,
				dateRange: {
					from: filters?.dateRange?.from,
					to: filters?.dateRange?.to,
				},
				status: filters?.status,
			};
		} else {
			setFilters({
				store: request?.store,
				dateRange: {
					from: moment(request?.dateRange?.from)?.format(
						'YYYY-MM-DD'
					),
					to: moment(request?.dateRange?.to)?.format('YYYY-MM-DD'),
				},
				status: request?.status,
				type: request?.type,
			});
		}
		const req = {
			data: {
				filters: {
					storeId: request?.store?.id,
					dateRangeFilter: {
						from: moment(request?.dateRange?.from)?.format(
							'YYYY-MM-DD'
						),
						to: moment(request?.dateRange?.to)?.format(
							'YYYY-MM-DD'
						),
					},
					type: request?.type,
					status: request?.status,
					auditId: isRefresh ? null : search ? Number(search) : null,
				},
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.fetchAuditList(req);
			if (response?.statusCode === 200) {
				setAuditList(
					response?.data?.map((ele) => {
						return {
							...ele,
							startDate: ele?.createdAt
								? moment(ele?.createdAt)?.format(
										'YYYY-MM-DD hh:mm:ss A'
								  )
								: '-',
							endDate: ele?.closedAt
								? moment(ele?.closedAt)?.format(
										'YYYY-MM-DD hh:mm:ss A'
								  )
								: '-',
						};
					})
				);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleReOpenAudit = async (currItem) => {
		const req = {
			data: {
				auditId: currItem?.id,
				storeId: currItem?.storeId,
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.reOpenAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits();
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Some error occured',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message ?? 'Some error occured',
			});
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleViewClick = async (currItem, disabled) => {
		console.log(currItem, 'currItem');
		const req = {
			data: {
				auditId: currItem?.id,
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.fetchAuditItems(req);
			console.log(currItem, 'currItem');
			if (response?.statusCode === 200) {
				const storeObj = storesList?.find(
					(s) => s?.id === currItem?.storeId
				);
				toggleModal(true, {
					items: response?.data?.report,
					auditId: currItem?.id,
					storeId: currItem?.storeId,
					storeSubType: storeObj?.subType,
					isDisabled: disabled,
					hideButtons: disabled,
					showInitiatedAuditItems: currItem?.status === 'SCHEDULED',
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};
	const handleScheduledViewClick = async (currItem) => {
		const req = {
			data: {
				auditId: currItem?.id,
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.fetchScheduledAuditItems(req);
			if (response?.statusCode === 200) {
				let selectedProducts = productsList;
				if (currItem?.productIds && currItem?.productIds?.length) {
					selectedProducts = currItem?.productIds?.map((ele) => {
						const product = productsList?.find((proItem) => {
							return proItem?.id === ele;
						});
						return product;
					});
				}
				toggleModal(true, {
					items: selectedProducts,
					categories: response?.data?.selectedCategories,
					skus: response?.data?.selectedSkus,
					auditId: currItem?.id,
					storeId: currItem?.storeId,
					storeName: currItem?.storeName,
					isDisabled: true,
					hideButtons: true,
					showGeneralDetails: true,
					showInitiatedAuditItems: currItem?.status === 'SCHEDULED',
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const onViewClick = (currItem) => {
		if (currItem?.status === 'SCHEDULED') {
			handleScheduledViewClick(currItem);
		} else {
			handleViewClick(currItem, true);
		}
	};

	const handleCancelAudit = async (currItem) => {
		const req = {
			data: {
				auditId: currItem?.id,
				storeId: currItem?.storeId,
				status: 'CANCELLED',
			},
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.cancelAudit(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				fetchAudits(filters);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [];
		const downloadBtn = document.createElement('a');
		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const handleExportNonQrItems = async (data) => {
		const headers = [
			'Item Code',
			'UY Item Id',
			'Store Id',
			'Store Code',
			// 'Store Name',
			'Product Name',
			'Variant Name',
			'Last Price',
			'unit',
			'Current Stock',
		];
		const exportData = [];
		data?.items?.forEach((item) => {
			exportData.push([
				item?.clientVariantId,
				item?.variantId,
				data?.storeId,
				data?.clientStoreId,
				item?.productName,
				item?.variantName,
				item?.lastPrice,
				item?.unit,
				item?.currentStock,
			]);
		});
		handleExcelDownload(
			headers,
			exportData,
			`Audit Report of Non QR Items for ${data?.storeName}`
		);
	};

	const handleExport = async (auditId) => {
		try {
			setIsLoading(true);
			const req = {
				data: {
					auditId,
				},
			};
			const response = await auditServices.fetchNonQrItems(req);
			if (response?.statusCode === 200) {
				handleExportNonQrItems(response?.auditReport);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while exporting data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleImport = async (auditId, uploadFile, storeId) => {
		try {
			setIsLoading(true);
			const req = {
				data: {
					auditId,
					updatedAudit: uploadFile?.file,
					storeId,
				},
			};
			const response = await auditServices.uploadNonQrItems(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while uploading data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const uploadAuditReport = (auditId, storeId) => {
		toggleUploadDataModal(true, {
			heading: 'Upload Audit Report of Non QR Items',
			auditId,
			storeId,
		});
	};

	const SPECIAL_ITEMS = {
		Type: (_, obj) => {
			return obj?.subType?.split('_')?.join(' ') ?? 'AUDIT';
		},
		'Created At / Activated At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return moment(currItem?.createdAt).format('YYYY-MM-DD hh:mm A');
		},
		'Scheduled/Start': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			if (!currItem?.scheduledAt && !currItem?.startDate) return '-';
			if (currItem?.scheduledAt) {
				return moment(new Date(currItem?.scheduledAt)).format(
					'YYYY-MM-DD hh:mm A'
				);
			}
			return currItem?.startDate;
		},
		'Scanning Completed At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['edit-container']}>
					<p>{currItem?.endDate ?? '-'}</p>
				</div>
			);
		},
		'Stock Adjustment At': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['edit-container']}>
					<p>
						{currItem?.stockAdjustmentAt
							? moment(
									new Date(currItem?.stockAdjustmentAt)
							  ).format('YYYY-MM-DD hh:mm A')
							: '-'}
					</p>
				</div>
			);
		},
		Status: (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			if (currItem?.status === 'CLOSED') {
				return 'SCANNING DONE';
			}
			return currItem?.status ?? '-';
		},
		'Store Name': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div
					style={{
						width: 125,
					}}
				>
					{currItem?.storeName}
				</div>
			);
		},
		'Bulk Action': (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			// const showImport = isInternal && userConfig?.userDetails?.level === 2;
			return (
				<div className='flex flex-col gap-2'>
					{(currItem?.status === 'CLOSED' ||
						currItem?.status === 'ACTIVE') && (
						<Button
							className='text-xs'
							variant='contained'
							color='primary'
							onClick={() => handleExport(currItem.id)}
						>
							<div className='flex items-start justify-start gap-1 text-sx'>
								<img
									className='size-4'
									src={excel}
									alt='excel'
								/>
								Export Non QR
							</div>
						</Button>
					)}
					{(currItem?.status === 'CLOSED' ||
						currItem?.status === 'ACTIVE') &&
						!levels.includes(level) && (
							<Button
								className='text-xs'
								variant='contained'
								color='primary'
								onClick={() =>
									uploadAuditReport(
										currItem.id,
										currItem.storeId
									)
								}
							>
								<div className='flex items-center justify-start gap-1 text-sx'>
									<Upload className='size-4' />
									Import Non QR
								</div>
							</Button>
						)}
				</div>
			);
		},
		Action: (id) => {
			const currItem = auditsList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles['action-btns']}>
					{currItem?.status === 'CLOSED' && (
						<>
							<Button
								variant='contained'
								color='primary'
								className='flex items-center justify-center gap-1'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Re-Open Audit',
										handleConfirm: () => {
											handleReOpenAudit(currItem);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Re-Open Audit ${
											currItem?.id || ''
										}?`,
									});
								}}
							>
								<RefreshCcw className='size-4 mr-1' />
								Re-Open
							</Button>
							<Button
								variant='outlined'
								color='primary'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Complete Audit',
										handleConfirm: () => {
											handleViewClick(
												currItem,
												currItem?.status !== 'CLOSED'
											);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you to Complete ${
											currItem?.id || ''
										}?`,
									});
								}}
							>
								Complete
							</Button>
						</>
					)}
					{!currItem?.status?.includes('COMPLETED') &&
						currItem?.status !== 'CANCELLED' && (
							<Button
								variant='outlined'
								color='error'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Cancel Audit',
										handleConfirm: () => {
											handleCancelAudit(currItem);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you to Cancel ${
											currItem?.id || ''
										}?`,
									});
								}}
							>
								Cancel
							</Button>
						)}
				</div>
			);
		},
	};

	// eslint-disable-next-line func-names
	const rowColor = function (status) {
		switch (status) {
			case 'ACTIVE':
				return styles.active;
			case 'COMPLETED':
			case 'COMPLETED - Stocking Out':
				return styles.complete;
			case 'CANCELLED':
				return styles.cancel;
			case 'SCHEDULED':
				return styles.scheduled;
			case 'CLOSED':
				return styles.done;
			default:
				return null;
		}
	};

	const handleAdjustStock = async (auditId, storeId, adjustments) => {
		const req = {
			data: {
				auditId,
				storeId,
				adjustments,
			},
		};
		try {
			const response = await auditServices.closeAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleModal(false, {});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while adjusting stock',
			});
		}
	};

	const handleAddClick = () => {
		toggleAuditCreationModal(true, {});
	};

	const handleConfirmCreation = async (auditCreationState) => {
		setIsLoading(true);
		const req = {
			data: {
				scheduled:
					auditCreationState?.scheduled !== 'NOW'
						? auditCreationState?.scheduled
						: null,
				storeIds: auditCreationState?.selectedStores,
				name: auditCreationState?.auditName,
				products: !auditCreationState?.isAllProduct
					? auditCreationState?.productsList
					: null,
				productSelection: auditCreationState?.productSelection,
				allProducts: auditCreationState?.isAllProduct,
			},
		};
		try {
			const response = await auditServices.createAudit(req);
			if (response?.statusCode === 200) {
				fetchAudits(filters);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Success',
				});
				toggleModal(false, {});
				toggleAuditCreationModal(false, {});
			} else if (response?.statusCode === 300) {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage,
				});
				// fetchAudits({
				// store: storeId,
				// dateRange: {
				// from: moment(
				// new Date().setDate(new Date().getDate() - 10)
				// )?.format('YYYY-MM-DD'),
				// to: moment(new Date())?.format('YYYY-MM-DD'),
				// },
				// });
				toggleAuditCreationModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleAuditExits = (storeId) => {
		setFilters({
			storeId,
			dateRange: {
				from: moment(new Date())?.format('YYYY-MM-DD'),
				to: moment(
					new Date().setDate(new Date().getDate() - 10)
				)?.format('YYYY-MM-DD'),
			},
		});
	};
	const handleOnUpdate = (finderFilters) => {
		const dateRange = {
			startDate: moment(finderFilters?.dateRange?.from).format(
				'YYYY-MM-DD'
			),
			endDate: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const req = {
			data: {
				filters: {
					storeId: finderFilters?.store,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
					},
					status: finderFilters?.status,
					type: finderFilters?.type,
				},
			},
		};
		exportFilters.current = req.data.filters;
	};
	const handleExportData = async (filters) => {
		const exportFilters = {
			storeId: filters?.store?.id,
			dateRangeFilter: {
				from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
			},
			status: filters?.status,
			type: filters?.type,
		};
		const req = {
			data: exportFilters,
		};
		try {
			setIsLoading(true);
			const response = await auditServices?.auditExport(req);
			const fileName = getFileName(exportFilters);
			handleResponseStreamDownload(response, fileName);
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: response.error,
			});
		} finally {
			setIsLoading(false);
		}
	};
	//  dropdown options
	const dropDownItems = [
		{
			label: 'Id',
			value: 'id',
			placeholder: 'Search by Audit ID',
			getData: true,
		},
		{
			label: 'Name',
			value: 'name',
			placeholder: 'Search by Audit Name',
			getData: false,
		},
	];

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
		},
		filteredStore: {
			text: 'Audits conducted at (Store)',
			show: true,
		},
		status: {
			text: 'Audit with status',
			show: true,
		},
		dateRangeOnly: {
			text: 'Scheduled Or Created At',
			show: true,
		},
		type: {
			text: 'Audit Type',
			show: true,
			list: [
				{
					label: 'Audit',
					type: 'AUDIT',
				},
				{
					label: 'Day End',
					type: 'DAY_END',
				},
			],
		},
	};

	useEffect(() => {
		if (search === '') {
			fetchAudits(filters);
		}
	}, [search]);

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			fetchAudits(filters);
		}
	};
	const exportInfo = {
		showExportBtn: true,
	};

	return (
		<div className={styles.root}>
			<AuditItemsModal handleConfirm={handleAdjustStock} />
			<UploadDataModal
				show={showUploadDataModal}
				heading={payload?.heading}
				storeId={payload?.storeId}
				auditId={payload?.auditId}
				handleImport={handleImport}
			/>
			<AuditCreationModal
				handleConfirm={handleConfirmCreation}
				onAuditExists={handleAuditExits}
			/>
			<BackdropLoader showProgress isLoading={isLoading} />
			<div>
				<div className='flex justify-between m-4 '>
					<span className='font-bold text-[16px]'>My Audits</span>
					{!levels.includes(level) && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Start Audit
						</Button>
					)}
				</div>
				<ImagesFinder
					onSubmit={fetchAudits}
					statusList={statusList}
					defaultState={{
						STORE: filters.store ?? { id: -999, name: '' },
						DATE_RANGE: {
							active: true,
							from: new Date(filters?.dateRange?.from),
							to: new Date(filters?.dateRange?.to),
						},
					}}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
			</div>
			<div className='flex gap-4 w-full justify-start items-center py-1'>
				<div className='w-[81%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSearchValue={setSearch}
						handleValue={handleCall}
						setSelectedValue={setSelectedOption}
						isRefresh={isRefresh}
					/>
				</div>
				<div className=' flex justify-between items-center gap-3'>
					<Tooltip title='Refresh audits'>
						<RefreshCcw
							className='size-5 cursor-pointer'
							onClick={() => {
								fetchAudits(filters, true);
							}}
						/>
					</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								handleDataExport: (filters) =>
									handleExportData(filters),
							});
						}}
						className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter and Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles['table-container']}>
				<ListTable
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={auditsList
						?.filter((item) =>
							search && selectedOption?.value === 'name'
								? item.name &&
								  item.name
										.toLowerCase()
										.includes(search.toLowerCase())
								: true
						)
						?.map((ele) => ({
							...ele,
							rowStyles: classes(
								styles.listItem,
								rowColor(ele?.status)
							),
						}))}
					actions={[
						...SPECIAL_COLUMNS,
						...getActionColumn(
							BASE_COLUMNS,
							ADDITIONAL_COLUMNS,
							level
						),
					]}
					special={SPECIAL_ITEMS}
					handleViewClick={(currItem) => {
						onViewClick(currItem);
					}}
					fixedHeaderTop='0'
					showBtnContainer={false}
					allowExport={false}
					pageName='My Audits'
				/>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;
	const storesList = state.form.STORES?.data?.LIST ?? [];
	const { uploadDataModal } = state.modal;
	const showUploadDataModal = uploadDataModal?.show;
	const payload = uploadDataModal?.data;
	return {
		navState,
		userPermissions,
		productsList,
		storesList,
		showUploadDataModal,
		payload,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleAuditItemsModal,
	toggleAuditCreationModal: modalActions.toggleAuditCreationModal,
	toggleAlert: modalActions.toggleAlert,
	fetchProducts: formActions.gateway,
	toggleUploadDataModal: modalActions.toggleUploadDataModal,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAuditsPage);
